"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBytes = void 0;
const helpers_1 = require("../helpers");
function randomBytes(length) {
    if (!helpers_1.isValidKeyLength(length)) {
        throw new Error(`randomBytes - invalid key length: ${length}`);
    }
    let result;
    if (helpers_1.isBrowser()) {
        result = helpers_1.browserRandomBytes(length);
    }
    else if (helpers_1.isNode()) {
        result = helpers_1.nodeRandomBytes(length);
    }
    else {
        result = helpers_1.fallbackRandomBytes(length);
    }
    return result;
}
exports.randomBytes = randomBytes;
//# sourceMappingURL=index.js.map